import React from "react";
import { Select, Empty } from "antd";
import _t from "../../languages/translate";
import { validateSelectFilter } from "../helper/helperMethods";

const SelectMulty = ({
  innerRef,
  placeholder = _t("strNotSelected"),
  opt = [],
  fieldNames = { label: "name", value: "id" },
  onChange,
  ...rest
}) => {
  return (
    <Select
      ref={innerRef}
      allowClear
      mode="multiple"
      size="small"
      showSearch
      optionFilterProp="children"
      notFoundContent={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      fieldNames={fieldNames}
      filterOption={(search, item) => {
        return validateSelectFilter(search, item);
      }}
      placeholder={placeholder}
      onChange={onChange}
      options={opt}
      {...rest}
    />
  );
};

export default SelectMulty;
